export function isMotionReduced(): boolean {
	return typeof window !== 'object' || window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}
